import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import moment from 'moment'

/**
 * Message page.
 * It displays single messages.
 * @Tags( page, layout, logged-users, message, api )
 * @Endpoints( /messages )
 * @ApiLogic( ../api/messages )
 * @Routes( /messages )
 */
const MessageDetalis = ({backToAllMessage, message}) => {
  const { t } = useTranslation() 
 
  return (
    <div className="messageDetalis">

      <div className="row messageDetalis__header">
        <div className="col-lg-12 text-right">
          {t('Message.date')}: {moment.utc(message.date_created).format('DD.MM.YYYY HH:mm')}
        </div>
      </div>

      <div className="row messageDetalis__title">
        <div className="col-12 col-lg">
          {message.title}
        </div>
      </div>

      <div className={'row messageDetalis__body'}>
        <div className="col-12 col-lg">
          {message.content}
          {message.id}
        </div>
      </div>

      <div className="messageDetalis__nav">
    
        <button onClick={()=>backToAllMessage()} type="button" className="bt bt-orange s-38">
          <i className="icon-arrow-left"></i>
          <span>{t('Message.back')}</span>
        </button>

      </div>

    </div>
  )
}

MessageDetalis.propTypes = {
  message: PropTypes.object.isRequired,
  backToAllMessage: PropTypes.func 
}


export default MessageDetalis
